import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { ContentLayout } from '../../components/layouts/ContentLayout';
import { useIncidentsFilterQuery } from '../../graphql/hooks/useIncidentsQuery';
import { useIncidentsFilter } from '../../hooks/useIncidentsFilter';
import { IncidentCreateModal } from './IncidentCreateModal';
import { IncidentsActionMenu } from './IncidentsActionMenu';
import { IncidentsFilterControls } from './IncidentsFilterControls';
import { IncidentsTable } from './IncidentsTable';

export const Incidents = () => {
  const filter = useIncidentsFilter();

  const { isLoading, error, incidents, refetch, pagination, rowSelection } =
    useIncidentsFilterQuery(filter);

  return (
    <ContentLayout
      headerContent={
        <ChakraV3.HStack align='start'>
          <ChakraV3.Heading size='3xl' fontWeight='bold'>
            Incidents
          </ChakraV3.Heading>
          <ChakraV3.Spacer />
          <ChakraV3.HStack>
            <ChakraV3.Button
              colorPalette='brand'
              size='sm'
              onClick={() => showModal(IncidentCreateModal)}
            >
              <FaPlus />
              Add incident
            </ChakraV3.Button>

            <IncidentsActionMenu filter={filter} size='sm' />
          </ChakraV3.HStack>
        </ChakraV3.HStack>
      }
    >
      <ChakraV3.Stack gap={4} px={6}>
        <IncidentsFilterControls filter={filter} />
        <IncidentsTable
          error={error}
          isLoading={isLoading}
          incidents={incidents}
          refetch={refetch}
          pagination={pagination}
          rowSelection={rowSelection}
        />
      </ChakraV3.Stack>
    </ContentLayout>
  );
};
